import { create } from 'zustand';
import { parseUA } from '@/utils/common';
const UA = parseUA();

const langMappgingList = [
  { key: 'en', code: 'en' },
  { key: 'en-US', code: 'en' },
  { key: 'en_US', code: 'en' },
  { key: 'en-GB', code: 'en' },
  { key: 'en-AU', code: 'en' },
  { key: 'en-CA', code: 'en' },
  { key: 'en-IN', code: 'en' },
  { key: 'zh', code: 'zh' },
  { key: 'zh-CN', code: 'zh' },
  { key: 'zh_CN', code: 'zh' },
  { key: 'zh-TW', code: 'tw' },
  { key: 'zh_TW', code: 'tw' },
  { key: 'zh_tw', code: 'tw' },
  { key: 'zh-tw', code: 'tw' },
  { key: 'es', code: 'es' },
  { key: 'es_LA', code: 'es' },
  { key: 'es_la', code: 'es' },
  { key: 'es-ES', code: 'es' },
  { key: 'es-MX', code: 'es' },
  { key: 'es-AR', code: 'es' },
  { key: 'es-CO', code: 'es' },
  { key: 'fr', code: 'fr' },
  { key: 'fr-FR', code: 'fr' },
  { key: 'fr-CA', code: 'fr' },
  { key: 'fr-BE', code: 'fr' },
  { key: 'de', code: 'de' },
  { key: 'de-DE', code: 'de' },
  { key: 'de-AT', code: 'de' },
  { key: 'de-CH', code: 'de' },
  { key: 'ru', code: 'ru' },
  { key: 'ja', code: 'ja' },
  { key: 'ko', code: 'ko' },
  { key: 'it', code: 'it' },
  { key: 'pt', code: 'pt' },
  { key: 'pt-PT', code: 'pt' },
  { key: 'pt-pt', code: 'pt' },
  { key: 'pt-BR', code: 'pt' },
  { key: 'th', code: 'th' },
  { key: 'vi', code: 'vi' },
  { key: 'tr', code: 'tr' },
  { key: 'id', code: 'id' },
  { key: 'hi', code: 'hi' },
  { key: 'bn', code: 'bn' },
];
const langMappging = {
  temp: 'temp',
  en: 'en',
  'en-US': 'en',
  en_US: 'en',
  'en-GB': 'en',
  'en-AU': 'en',
  'en-CA': 'en',
  'en-IN': 'en',
  zh: 'zh',
  'zh-CN': 'zh',
  zh_CN: 'zh',
  zh_TW: 'tw',
  'zh-TW': 'tw',
  zh_tw: 'tw',
  'zh-tw': 'tw',
  es: 'es',
  es_LA: 'es',
  es_la: 'es',
  'es-ES': 'es',
  'es-MX': 'es',
  'es-AR': 'es',
  'es-CO': 'es',
  fr: 'fr',
  'fr-FR': 'fr',
  'fr-CA': 'fr',
  'fr-BE': 'fr',
  de: 'de',
  'de-DE': 'de',
  'de-AT': 'de',
  'de-CH': 'de',
  ru: 'ru',
  ja: 'ja',
  ko: 'en',
  it: 'it',
  pt: 'pt',
  'pt-PT': 'pt',
  'pt-pt': 'pt',
  'pt-BR': 'pt',
  th: 'th',
  vi: 'vi',
  tr: 'tr',
  id: 'id',
  hi: 'hi',
  bn: 'bn',
};
interface GlobalState {
  isInApp: boolean;
  appName: string;
  launchParams: any;
  jwt: string;
  jwtOverride: boolean; // jwt是否已过期
  pageInfo: PageInfoResponse | undefined;
  isClaiming: boolean; // 是否正在调用claim接口
  appHeaderReady: boolean; // appHeader数据是否已经获取且初始化好
  bgwheadInfo: BitkeepInter;
  theme: string;
  token: string;
  // 临时禁用 eslint 规则，等待类型定义完善后移除
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultLangs: any[];
  identity?: string;
  // 临时禁用 eslint 规则，等待类型定义完善后移除
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chainObj?: any;
  langs: object;
  langsList: { key: string; code: string }[];
  newerQuest: {
    id: number;
    task_name: string;
  };
  curTaskId: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useGlobalStore = create<GlobalState>(set => ({
  newerQuest: {
    id: 0,
    task_name: '',
  },
  langsList: langMappgingList,
  langs: langMappging,
  defaultLangs: [
    'zh_CN',
    'zh-CN',
    'zh_TW',
    'zh_tw',
    'en-US',
    'en_US',
    'zh-TW',
    'zh-tw',
    'es_la',
    'pt-pt',
    'ar',
    'bn',
    'de',
    'en',
    'es',
    'fr',
    'hi',
    'id',
    'ja',
    'ko',
    'pt',
    'ru',
    'th',
    'tr',
    'vi',
    'zh',
    'tw',
  ],
  theme: '0',
  isInApp: false,
  appName: '',
  launchParams: null,
  jwt: '',
  jwtOverride: false,
  pageInfo: undefined,
  isClaiming: false,
  // test token
  // token: '0a1cf783eacf493511f632cf2623c65b',
  token: '',
  identity: '',
  chainObj: null,
  appHeaderReady: false,
  bgwheadInfo: {
    language: 'en',
    currency: 'usd',
    CURRENCY: 'usd',
    os: UA.os ?? '',
    package: 'com.bitkeep.h5',
    token: '',
    mylanguage: 'en',
    brand: 'web',
    clientversion: '2.0.0',
    im: '',
    // test im
    // IM: 'BK7809c23a-c6bd-454c-9c84-7351dc61c203-ggruhbn7pj',
    IM: '',
    seqnum: '',
    sig: '',
    LANGUAGE: 'en',
  },
  curTaskId: '',
}));
